import { useState } from 'react';
import { useLearningProgress } from '../../../hooks/useLearningProgress';
import LearningProgressPanel from './LearningProgressPanel';

export default function LearningProgressButton() {
  const [open, setOpen] = useState(false);
  const { percentage, visitedCount, totalCount } = useLearningProgress();

  const color = percentage < 20 ? '#34D399' : percentage < 40 ? '#60A5FA' : percentage < 60 ? '#F59E0B' : percentage < 80 ? '#F472B6' : '#7C3AED';

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        className="fixed bottom-24 right-4 z-40 flex items-center gap-2 px-3 py-2.5 rounded-2xl cursor-pointer transition-all hover:scale-105 active:scale-95"
        style={{ background: 'white', border: `2px solid ${color}30`, boxShadow: `0 4px 20px ${color}20` }}
        title="我的学习进度"
      >
        {/* Mini circular progress */}
        <div className="relative w-8 h-8 shrink-0">
          <svg className="w-8 h-8 -rotate-90" viewBox="0 0 32 32">
            <circle cx="16" cy="16" r="12" fill="none" stroke="#F3F4F6" strokeWidth="3" />
            <circle
              cx="16" cy="16" r="12" fill="none"
              stroke={color} strokeWidth="3"
              strokeDasharray={`${2 * Math.PI * 12}`}
              strokeDashoffset={`${2 * Math.PI * 12 * (1 - percentage / 100)}`}
              strokeLinecap="round"
              style={{ transition: 'stroke-dashoffset 0.5s ease' }}
            />
          </svg>
          <div className="absolute inset-0 flex items-center justify-center">
            <span className="text-[9px] font-black" style={{ color }}>{percentage}%</span>
          </div>
        </div>
        <div className="text-left">
          <div className="text-xs font-black text-gray-800 leading-none">学习进度</div>
          <div className="text-[10px] text-gray-400 mt-0.5">{visitedCount}/{totalCount} 板块</div>
        </div>
      </button>

      {open && <LearningProgressPanel onClose={() => setOpen(false)} />}
    </>
  );
}
